export enum TableStateEnum {
  Refreshing = 'REFRESHING',
  Loading = 'LOADING',
  Loaded = 'LOADED',
  NoData = 'NO_DATA',

}